module.exports = __webpack_public_path__ + "img/income.8172dcea.svg";